import ScaledTemplate from '../Tabs/ScaledTemplate';

function App(props) {

  var isFEOrPU = props.isFEOrPU;
  var insetWidth = props.insetWidth;
  var overallWidth = props.overallWidth;
  var insetHeight = props.insetHeight;
  var expressedWidth = props.expressedWidth;

  var currentList = props.currentList;
  var chains = props.chains;
  var aTemplate = props.aTemplate;
  var onClick = props.onClick;

//

  var w = (expressedWidth - 180);
  var h = (expressedWidth - 180) * (insetHeight - 42)/insetWidth;

  var cListCleaned = {s:{},oc:{},sc:{},as:aTemplate.as, _g:currentList._g};
  cListCleaned[isFEOrPU] = {'1':aTemplate.v};
  return <ScaledTemplate chains={chains} overallWidth={overallWidth} w={w} h={h} error={false} whichFEOrPU={{t:isFEOrPU, v:'1'}} currentList={cListCleaned} onClick={onClick} offsetTop={0} offsetLeft={0}/>



}


//
export default App;
